import React__default from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { useCart } from '../context/Cart/context.js';
import { mapLineItemToDataLayerEvent } from '../mappers/analytics/data-layer/line-item-to-data-layer-event.js';

const getSanitizationPayloads = (actionItem)=>{
    const { action , actioneeSKU , lineItemId  } = actionItem;
    return {
        action,
        actioneeSKU,
        lineItemId
    };
};
const getConflictingLineItems = (sanitizationPayloads, cart)=>{
    if (!cart || !sanitizationPayloads) {
        return null;
    }
    const conflictingLineItemIds = sanitizationPayloads.map((payload)=>payload.lineItemId
    );
    return cart.lineItems.filter((lineItem)=>conflictingLineItemIds.find((id)=>id === lineItem.id
        )
    );
};
const useSanitization = ()=>{
    const [isModalOpen, setIsModalOpen] = React__default.useState(false);
    const [validation, setValidation] = React__default.useState(null);
    const [sanitizationPayloads1, setSanitizationPayloads] = React__default.useState(null);
    const { cart  } = useCart();
    const conflictingLineItems = React__default.useRef(null);
    const data = {
        sanitizationPayloads: sanitizationPayloads1,
        isModalOpen,
        validation
    };
    const onSolvableValidationError = React__default.useCallback((solvableValidationErrors)=>{
        if (solvableValidationErrors.length > 0) {
            const actions = solvableValidationErrors.map((error)=>error.actionItem.action
            );
            /** When all sanitization actions are the same, confirm will resolve all validation errors at once */ if (solvableValidationErrors.length > 1 && actions.every((val, _i, arr)=>val === arr[0]
            )) {
                const sanitizationPayloads = solvableValidationErrors.map((error)=>getSanitizationPayloads(error.actionItem)
                );
                conflictingLineItems.current = getConflictingLineItems(sanitizationPayloads, cart);
                setValidation({
                    validationError: solvableValidationErrors[0],
                    singleValidation: false
                });
                setSanitizationPayloads(sanitizationPayloads);
            } else {
                const sanitizationPayloads = [
                    getSanitizationPayloads(solvableValidationErrors[0].actionItem), 
                ];
                conflictingLineItems.current = getConflictingLineItems(sanitizationPayloads, cart);
                setValidation({
                    validationError: solvableValidationErrors[0],
                    singleValidation: true
                });
                setSanitizationPayloads(sanitizationPayloads);
            }
            setIsModalOpen(true);
        }
    }, [
        cart
    ]);
    const pushRemoveLineItemDataLayerEvent = React__default.useCallback(()=>{
        const lineItems = conflictingLineItems.current;
        if (!lineItems) {
            return;
        }
        const removeFromCartEvent = mapLineItemToDataLayerEvent(DataLayer.DataLayerTypes.EventType.remove, lineItems, (cart === null || cart === void 0 ? void 0 : cart.id) || '');
        removeFromCartEvent && DataLayer.pushEcommerceEvent(removeFromCartEvent);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.id
    ]);
    const reset = React__default.useCallback(()=>{
        setIsModalOpen(false);
        setValidation(null);
        setSanitizationPayloads(null);
        conflictingLineItems.current = null;
    }, [
        setIsModalOpen,
        setValidation,
        setSanitizationPayloads
    ]);
    return [
        data,
        {
            onSolvableValidationError,
            pushRemoveLineItemDataLayerEvent,
            reset
        }, 
    ];
};

export { useSanitization };
//# sourceMappingURL=use-sanitization.js.map
